import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useQuery } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

export type GetCommentParams = {
  type: string
  userThreatId: number
}

export const getComments = async (params: GetCommentParams) => {
  return axios.get(endpoints.getComment, { params })
}

export const useGetComments = (params: GetCommentParams) => {
  return useQuery([ApiKey.comment, ApiKey.message, params], () => getComments(params))
}
